import { stripTags } from "../utils";

export interface PerRowEdits {
    [rowIndex: number]: { [columnIndex: number]: { value: any; notes?: string } };
}

export const stripTransientColumnData = (column: any) => {
    if (!column || typeof column !== "object") {
        return column;
    }

    const { form: _form, dueInventoryItem: _dueInventoryItem, ...rest } = column;
    return rest;
};

export const isPerRowColumn = (column: any) => {
    return column?.field?.name === "inventory_item_select";
};

export const isBulkLockedColumn = (column: any) => {
    return (
        column?.type === "imageUpload" ||
        isPerRowColumn(column) ||
        /m(a|ä)ngel/i.test(stripTags(column?.title || ""))
    );
};

export const applyMultiRowEdit = (
    data: any[][],
    activeRows: number[],
    editingRow: any[],
    perRowEdits: PerRowEdits,
    columns: any[]
) => {
    return data.map((dataRow, rowIndex) => {
        if (!activeRows.includes(rowIndex)) {
            return dataRow;
        }

        return dataRow.map((v, columnIndex) => {
            const baseCell = {
                ...stripTransientColumnData(v),
                field: null,
            };

            const perRowEdit = perRowEdits?.[rowIndex]?.[columnIndex];
            if (perRowEdit && (isPerRowColumn(columns[columnIndex]) || isPerRowColumn(v))) {
                const cell: any = {
                    ...(v ? {} : stripTransientColumnData(columns[columnIndex])),
                    ...baseCell,
                    value: perRowEdit.value,
                };
                if (perRowEdit.notes !== undefined) {
                    cell.notes = perRowEdit.notes;
                }
                return cell;
            }

            if (
                isBulkLockedColumn(columns[columnIndex]) ||
                isBulkLockedColumn(editingRow[columnIndex])
            ) {
                return baseCell;
            }

            if (editingRow[columnIndex] && editingRow[columnIndex].value) {
                return {
                    ...baseCell,
                    value: editingRow[columnIndex].value,
                };
            }

            return baseCell;
        });
    });
};
